let Jotform = {
    init: function () {
        this.bind();
    },

    bind: function () {
        this.form();
        this.delete();
        this.slug();
    },

    delete: function () {
        $('.delete-jotform').click(function () {
            let id = $(this).data('id');
            let row = $(this).closest('tr');

            swal({
                title: "Are you sure?",
                text: "Your will not be able to recover this record!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: "Yes, delete it!"
            }).then((result) => {
                if (result.value) {
                    $.post('/pages/jotforms/' + id,
                        {
                            _method: 'delete'
                        },
                        (result) => {
                            if (result.success) {
                                let table = row.closest('table').DataTable();
                                table.row(row).remove().draw();
                                swal(
                                    'Deleted!',
                                    'Record has been deleted.',
                                    'success'
                                ).then((result) => {

                                });
                            }
                        });
                }
            });
        });
    },

    form: function () {
        let _this = this;
        const jotformForm = $('#jotformForm');

        if (jotformForm.length) {
            let submitBtn = Ladda.create(jotformForm.find('[type=submit]')[0]);

            jotformForm.ajaxForm({
                beforeSubmit: function () {
                    $('.form-group').removeClass('has-error');
                    submitBtn.start();
                },
                success: function (response) {
                    if (response.success) {
                        toastr.success(response.message);
                        setTimeout(() => {
                            window.location.assign('/pages/jotforms');
                        }, 1000);
                    } else {
                        submitBtn.stop();
                        toastr.error(response.message);
                    }
                },
                error: function (err) {
                    submitBtn.stop();

                    let error = err.responseJSON;

                    if (error.errors) {
                        toastr.error(Object.values(error.errors).join('<br>')).css("width", "500px");
                        Object.keys(error.errors).forEach(field => {
                            $('[name=' + field + ']').closest('.form-group').addClass('has-error');
                        });
                    } else {
                        toastr.error(error.message);
                    }

                }
            });
        }

        $('#jotformsTable').on('draw.dt', function () {
            _this.delete();
        });
    },

    slug() {
        $(document).on('blur', '#jotformTitle', function (e) {
            const title = $(this).val();
            const slug = $('#jotformSlug');

            if (slug.val() === '') {
                slug.val(slugify(title));
            }
        });
    },
};

$().ready(function () {
    window.Jotform = Jotform;
    window.Jotform.init();
});
